import { Component, Input, OnChanges } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexLegend,
  ApexPlotOptions,
  ApexTitleSubtitle,
  ApexTooltip
} from "ng-apexcharts";

import { SharedService } from '@app/core';

type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  colors: string[];
  tooltip: ApexTooltip;
};
@Component({
  selector: 'app-treemap-chart',
  templateUrl: './treemap.component.html',
  styleUrls: ['./treemap.component.scss']
})
export class TreemapChartComponent implements OnChanges {
  @Input() series: {
    x: any;
    y: any;
    fill?: ApexFill;
    fillColor?: string;
    strokeColor?: string;
    meta?: any;
    goals?: any;
    barHeightOffset?: number;
    columnWidthOffset?: number;
  }[] | [number, number | null][] | [number, (number | null)[]][] | number[][];
  @Input() customTooltip: ((options: any) => any) | ((options: any) => any)[];
  chartOptions: Partial<ChartOptions>;

  constructor(private sharedService: SharedService) { }

  ngOnChanges() {
    const customColors = ["#3B93A5", "#F7B844", "#ADD8C7", "#EC3C65", "#CDD7B6", "#C1F666", "#D43F97", "#1E5D8C", "#421243", "#7F94B0", "#EF6537", "#C0ADDB"];

    this.chartOptions = {
      series: [{
        data: this.series.map(item => ({
          ...item,
          x: this.sharedService.capitalize(item.x),
        }))
      }],
      legend: {
        show: false
      },
      chart: {
        height: 385,
        type: "treemap"
      },
      tooltip: {
        enabled: true,
        followCursor: true,
        fillSeriesColor: true,
        theme: 'light',
        custom: this.customTooltip,
      },
      colors: customColors,
      dataLabels: {
        enabled: true,
        formatter: (text: any, op: any) => {
          const percentage = op.w.globals.initialSeries[0].data.find((seriesObject) => seriesObject.x == text).meta.percentage;
          if (text.length > percentage) {
            return text.substring(0, Math.floor(percentage + 6)) + '...';
          } else {
            return text
          }
        }
      },
      plotOptions: {
        treemap: {
          distributed: true,
          enableShades: false
        }
      }
    };
  }
}